import React from 'react';
import { makeStyles } from '@mui/styles';
import Menu from './Menu';
import { Box, Container, Grid, Typography } from '@mui/material';
import PageSection from './PageSection';
import ActionButton from './ActionButton';
import config from '../config';
import i18next from 'i18next';
import Image from 'next/image';

const useStyles = makeStyles(theme => ({
  mainHeader: {
    fontSize: 48,
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: 0,
    // color: 'white',
  },
  secondaryHeader: {
    // fontSize: 24,
    // // color: '#d2d2d2',
    // letterSpacing: 0,
    // // textShadow: 'rgb(0 0 0 / 40%) 0px 4px 5px',
    // maxWidth: 550,
    // marginTop: 20,
    // lineHeight: 1.44,
  },
}));

const PageHeader = ({ title, subTitle, backgroundImage, pageName }) => {
  const classes = useStyles();

  return (
    <PageSection
      style={{ backgroundImage: `url("${'' || '/images/covers/content.png'}")`, backgroundPosition: 'bottom' }}>
      <Menu />
      <Container maxWidth="md">
        <Box mt={'50px'}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="h1" className={classes.mainHeader} gutterBottom>
                {title}
              </Typography>
              <Typography variant="h4" color="textSecondary" className={classes.secondaryHeader} paragraph>
                {subTitle}
              </Typography>

              <ActionButton
                justify={'flex-start'}
                link={`${config.appUrl}/register?utm_action_source=${pageName}_page_header`}
                text={i18next.t('index.header.action.try_for_free')}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              {backgroundImage && (
                <Image unoptimized={true} src={backgroundImage} alt={'System Screenshot'} width={452} height={297} />
              )}
            </Grid>
          </Grid>
        </Box>
      </Container>
    </PageSection>
  );
};

PageHeader.propTypes = {};

export default PageHeader;
